import { Popover as HeadlessPopover } from "@headlessui/react"
import { PopoverPanel } from "shared-web/components/base/overlay/Popover"

import PopoverMultiSelectButton from "./PopoverMultiSelectButton"
import PopoverMultiSelectCombobox from "./PopoverMultiSelectCombobox"
import { PopoverMultiSelectProps } from "./types"

function PopoverMultiSelect({
  items,
  selected,
  onSelect,
  onChangeQuery,
  label,
  placeholder,
  disabled,
  invalid,
  errorMessage,
  className,
}: PopoverMultiSelectProps) {
  return (
    <HeadlessPopover className={className}>
      <PopoverMultiSelectButton
        label={label}
        placeholder={placeholder}
        selected={selected}
        onSelect={onSelect}
        disabled={disabled}
        invalid={invalid}
        errorMessage={errorMessage}
      />
      <PopoverPanel>
        <PopoverMultiSelectCombobox
          items={items}
          selected={selected}
          onSelect={onSelect}
          onChangeQuery={onChangeQuery}
        />
      </PopoverPanel>
    </HeadlessPopover>
  )
}

export default PopoverMultiSelect
